<div
  class="text-center"
  [ngClass]="badgeClasses"
  [class.w-full]="fullWidth()"
  [class.truncate]="truncate()"
  [style.color]="statusColor()"
  [style.border-color]="statusColor()"
  [style.background-color]="statusTint()"
>
  {{ description }}
</div>
